import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.update()
  }

  update() {
    this.element.toggleAttribute("data-scrolled", window.scrollY > 32)
  }
}
